module.exports = __webpack_public_path__ + "8f17b591d428c0b0e5e254a4dafda7cb.png";